import * as React from "react";
import { Id } from "@repo/convex/convex/_generated/dataModel";
import { api } from "@repo/convex/convex/_generated/api";
import { MessageAndAvatarRow } from "./MessageAndAvatarRow.tsx";
import { useQuery } from "convex-helpers/react/cache/hooks";

interface Props {
  chatId: Id<"itemChats">;
}

export const ChatMessagesList: React.FC<Props> = ({ chatId }) => {
  const messages = useQuery(api.itemChatMessages.listMyMessagesForChat, { chatId });
  const endRef = React.useRef<HTMLDivElement>(null);

  // Keep the newest message in view as they arrive
  React.useEffect(() => {
    endRef.current?.scrollIntoView({ block: "end" });
  }, [messages?.length, messages?.[messages.length - 1]?.message]);

  if (!messages) return <div className="chat-messages" />;
  return (
    <div className="chat-messages">
      {messages.length == 0 && (
        <p className="chat-empty">
          Ask anything about it: a summary, what it says about something, or whether it's worth
          your time.
        </p>
      )}
      {messages.map((message) => (
        <MessageAndAvatarRow key={message._id} message={message} />
      ))}
      <div ref={endRef} />
    </div>
  );
};
